import {gsap} from '../../_Global/js/global';

document.addEventListener('DOMContentLoaded', () => {
    const menu = document.querySelector('.megaMenu');

    function mobileFocusTrap(e) {
        const {target, currentTarget, key, shiftKey} = e;
        const hiddenTabs = [...currentTarget.querySelectorAll('.megaMenuTabContent')].filter((menu) =>
            menu && !menu.classList.contains('active') ? menu.querySelectorAll('a, button') : null,
        );
        const hiddenTabLinks = [];

        hiddenTabs && hiddenTabs.forEach((tab) => hiddenTabLinks.push(...tab.querySelectorAll('a, button')));

        // some menu items have tabs, we need to filter out hidden content from the focus list
        const allContent = [...currentTarget.querySelectorAll('a, button')].filter((node) => !hiddenTabLinks.includes(node));
        const firstNode = allContent.at(0);
        const lastNode = allContent.at(-1);

        if (key.match(/tab/i)) {
            // shift + tab
            if (shiftKey) {
                if (target === firstNode) {
                    e.preventDefault();

                    lastNode.focus();
                }

                return;
            }

            // tab
            if (target === lastNode) {
                e.preventDefault();

                firstNode.focus();
            }
        }
    }

    if (menu) {
        const closeButtons = document.querySelectorAll('.megaMenuClose');
        const backButtons = document.querySelectorAll('.megaMenuBack');
        const menuButtons = document.querySelectorAll('.megaMenuButton');
        const tabButtons = document.querySelectorAll('.megaMenuTab');
        const megaButtons = document.querySelectorAll('.button--mega');
        const megaContent = document.querySelectorAll('.megaMenuContent');
        //const tabContent = document.querySelectorAll('.megaMenuTabContent');
        const hoverStartEvents = ['mouseenter', 'touchstart', 'touchmove', 'pointerenter'];
        const hoverEndEvents = ['mouseleave', 'touchend', 'touchcancel', 'pointerleave', 'pointercancel', 'pointerup', 'pointerout', 'lostpointercapture'];
        const focusStartEvents = ['focus'];
        const focusEndEvents = ['blur'];

        menuButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
        tabButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));

        const animateOut = (button) => {
            if (!button.classList.contains('active')) {
                const buttonRect = button.getBoundingClientRect();
                const buttonTo = buttonRect.width + 80;

                gsap.to(button, {
                    duration: 0.5,
                    '--pseudo-left': buttonTo + 'px',
                    ease: 'power1.in',
                    onComplete: () => {
                        button.style.setProperty('--pseudo-left', '2000px');
                    },
                });
            }
        };

        const animateIn = (button) => {
            if (!button.classList.contains('active')) {
                const buttonRect = button.getBoundingClientRect();
                const buttonFrom = buttonRect.width * -1 - 80;

                gsap.fromTo(button, {'--pseudo-left': buttonFrom + 'px'}, {'--pseudo-left': '-20px', duration: 0.5, ease: 'power1.in'});
            }
        };

        megaButtons.forEach((button) => {
            button.style.setProperty('--pseudo-left', '-2000px');

            hoverStartEvents.forEach((type) => {
                button.addEventListener(type, function () {
                    button.classList.add('hover');

                    if (!button.classList.contains('focus')) {
                        animateIn(button);
                    }
                });
            });

            hoverEndEvents.forEach((type) => {
                button.addEventListener(type, function () {
                    button.classList.remove('hover');

                    if (!button.classList.contains('focus')) {
                        animateOut(button);
                    }
                });
            });

            focusStartEvents.forEach((type) => {
                button.addEventListener(type, function () {
                    button.classList.add('focus');
                    if (!button.classList.contains('hover')) {
                        animateIn(button);
                    }
                });
            });

            focusEndEvents.forEach((type) => {
                button.addEventListener(type, function () {
                    button.classList.remove('focus');
                    if (!button.classList.contains('hover')) {
                        animateOut(button);
                    }
                });
            });
        });

        menuButtons.forEach((button, i) => {
            button.addEventListener('click', () => {
                const newContent = button.closest('li').querySelector('.megaMenuContent');
                const currentActiveContent = document.querySelector('.megaMenuContent.active');
                //const activeTab = megaContent[i].querySelector(".megaMenuTabContent.active");
                const tab = megaContent[i].querySelector('.megaMenuTab.active');

                if (button.classList.contains('active')) {
                    return;
                }

                menuButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
                tabButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));

                if (tab) {
                    tab.setAttribute('aria-expanded', 'true');
                }

                button.setAttribute('aria-expanded', 'true');

                // if the device is smaller that 1200 px wide
                // enforce a focus trap on the second level nav
                if (window.innerWidth <= 1200) {
                    newContent.removeEventListener('keydown', mobileFocusTrap);
                    newContent.addEventListener('keydown', mobileFocusTrap);
                } else {
                    newContent.removeEventListener('keydown', mobileFocusTrap);
                }

                menuButtons.forEach((btn) => {
                    if (btn.classList.contains('active')) {
                        btn.classList.remove('active');
                        animateOut(btn);
                    }
                });

                button.classList.add('active');

                if (currentActiveContent) {
                    gsap.to(currentActiveContent, {
                        opacity: 0,
                        duration: 0.2,
                        onComplete: () => {
                            currentActiveContent.classList.remove('active');

                            newContent.classList.add('active');
                            gsap.fromTo(newContent, {opacity: 0}, {opacity: 1, duration: 0.3, ease: 'power2.out'});
                        },
                    });
                } else {
                    newContent.classList.add('active');
                    gsap.fromTo(newContent, {opacity: 0}, {opacity: 1, duration: 0.3, ease: 'power2.out'});
                }
            });
        });

        tabButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const targetId = button.getAttribute('data-target');
                const currentActiveContent = document.querySelector('.megaMenuTabContent.active');

                menuButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
                tabButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));

                button.setAttribute('aria-expanded', 'true');

                if (currentActiveContent && currentActiveContent.id === targetId) {
                    return;
                }

                tabButtons.forEach((btn) => btn.classList.remove('active'));
                button.classList.add('active');

                if (currentActiveContent) {
                    gsap.to(currentActiveContent, {
                        opacity: 0,
                        duration: 0.2,
                        onComplete: () => {
                            currentActiveContent.classList.remove('active');

                            const newContent = document.getElementById(targetId);

                            newContent.classList.add('active');
                            newContent.setAttribute('aria-expanded', 'true');

                            gsap.fromTo(newContent, {opacity: 0}, {opacity: 1, duration: 0.3, ease: 'power2.out'});
                        },
                    });
                } else {
                    const newContent = document.getElementById(targetId);
                    newContent.classList.add('active');
                    gsap.fromTo(newContent, {opacity: 0}, {opacity: 1, duration: 0.3, ease: 'power2.out'});
                }
            });
        });

        if (tabButtons.length > 0) {
            tabButtons[0].click();

            tabButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
        }

        closeButtons.forEach((button) => {
            button.addEventListener('click', () => {
                document.querySelector('html').classList.remove('no-scroll');

                gsap.to(menu, {
                    opacity: 0,
                    duration: 0.5,
                    onComplete: () => {
                        menu.classList.remove('active');
                    },
                });
            });
        });

        backButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const activeContent = button.closest('.megaMenuContent');
                const activeButton = activeContent.closest('li').querySelector('.megaMenuButton');

                activeButton.classList.remove('active');
                animateOut(activeButton);

                gsap.to(activeContent, {
                    opacity: 0,
                    duration: 0.5,
                    onComplete: () => {
                        activeContent.classList.remove('active');
                    },
                });
            });
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                if (menu.classList.contains('active')) {
                    document.querySelector('html').classList.remove('no-scroll');

                    gsap.to(menu, {
                        opacity: 0,
                        duration: 0.5,
                        onComplete: () => {
                            menu.classList.remove('active');
                        },
                    });
                }
            }
        });
    }
});
